export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    country: '🇬🇧',
    rating: 5,
    comment: 'Apartamento impecável com uma vista deslumbrante! A localização é perfeita e o check-in foi super fácil. Voltaremos com certeza!',
    platform: 'Booking.com',
    avatar: 'https://public.readdy.ai/ai/img_res/1ee409b650242b0ffa45e28609f868c4.jpg',
  },
  {
    id: 2,
    name: 'Marco Rossi',
    country: '🇮🇹',
    rating: 5,
    comment: 'Esperienza fantastica! L\'appartamento è moderno, pulito e la vista sull\'oceano è mozzafiato. Host molto disponibile.',
    platform: 'Airbnb',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20smiling%20man%20in%20his%2040s%20with%20dark%20hair%2C%20neutral%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=128&height=128&seq=test2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Emma Schmidt',
    country: '🇩🇪',
    rating: 5,
    comment: 'Perfekte Unterkunft für unseren Madeira-Urlaub! Sehr sauber, gut ausgestattet und die Lage ist ideal. Absolut empfehlenswert!',
    platform: 'Booking.com',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20smiling%20woman%20in%20her%2030s%20with%20brown%20hair%2C%20neutral%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=128&height=128&seq=test3&orientation=squarish',
  },
  {
    id: 4,
    name: 'João Silva',
    country: '🇵🇹',
    rating: 5,
    comment: 'Excelente alojamento! Tudo muito limpo e organizado. A vista é incrível e a comunicação com os anfitriões foi perfeita.',
    platform: 'Airbnb',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20smiling%20man%20in%20his%2030s%20with%20dark%20hair%2C%20neutral%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=128&height=128&seq=test4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Sophie Martin',
    country: '🇫🇷',
    rating: 5,
    comment: 'Magnifique appartement avec une vue spectaculaire! Très bien équipé et idéalement situé. Nous avons adoré notre séjour!',
    platform: 'Booking.com',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20smiling%20woman%20in%20her%2030s%20with%20blonde%20hair%2C%20neutral%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=128&height=128&seq=test5&orientation=squarish',
  },
];